// 한국어 초성 검색 유틸리티
const CHOSUNG_LIST = [
  'ㄱ', 'ㄲ', 'ㄴ', 'ㄷ', 'ㄸ', 'ㄹ', 'ㅁ', 'ㅂ', 'ㅃ',
  'ㅅ', 'ㅆ', 'ㅇ', 'ㅈ', 'ㅉ', 'ㅊ', 'ㅋ', 'ㅌ', 'ㅍ', 'ㅎ'
];

/**
 * 한글 문자열에서 초성만 추출
 * @param {string} str - 한글 문자열
 * @returns {string} - 초성만 추출된 문자열
 */
export const getChosung = (str) => {
  if (!str) return '';
  
  return str.split('').map(char => {
    const code = char.charCodeAt(0);
    
    // 한글 완성형 문자인지 확인 (가-힣)
    if (code >= 0xAC00 && code <= 0xD7A3) {
      // 초성 인덱스 계산
      const chosungIndex = Math.floor((code - 0xAC00) / 588);
      return CHOSUNG_LIST[chosungIndex];
    }
    
    // 이미 초성인 경우 그대로 반환
    if (CHOSUNG_LIST.includes(char)) {
      return char;
    }
    
    // 한글이 아닌 경우 그대로 반환
    return char;
  }).join('');
};

/**
 * 초성 검색 함수
 * @param {string} text - 검색 대상 텍스트
 * @param {string} query - 검색 쿼리
 * @returns {boolean} - 매칭 여부
 */
export const matchesChosung = (text, query) => {
  if (!text || !query) return false;
  
  const textChosung = getChosung(text);
  const queryChosung = getChosung(query);
  
  // 초성만으로 검색 (일반 문자열 검색과 분리)
  return textChosung.includes(queryChosung);
};

/**
 * 텍스트 검색 함수 (초성 + 일반 검색 통합)
 * @param {string} text - 검색 대상 텍스트
 * @param {string} query - 검색 쿼리
 * @returns {boolean} - 매칭 여부
 */
export const searchText = (text, query) => {
  if (!text || !query) return false;
  
  // 쿼리가 모두 초성인지 확인
  const isChosungQuery = query.split('').every(char => CHOSUNG_LIST.includes(char));
  
  if (isChosungQuery) {
    // 초성 검색
    return matchesChosung(text, query);
  } else {
    // 일반 텍스트 검색 (대소문자 무시)
    return text.toLowerCase().includes(query.toLowerCase());
  }
};



// 테스트용 예제
/*
console.log(getChosung('스위트보난자')); // 'ㅅㅇㅌㅂㄴㅈ'
console.log(matchesChosung('스위트보난자', 'ㅅㅇㅌ')); // true
console.log(matchesChosung('프라그마틱플레이', 'ㅍㄹㄱ')); // true
console.log(matchesChosung('에볼루션게이밍', 'ㅇㅂㄹ')); // true
console.log(searchGame('ㅅㅇㅌ')); // 스위트보난자 포함 결과
console.log(searchProvider('ㅇㅂㄹ')); // 에볼루션 포함 결과
*/ 